import EntityModel from '@/common/models/entity-model';
import ProductModel from '@/common/models/product-model';
import PlanModel from '@/common/models/plan-model';

export default class InvoiceItemModel extends EntityModel {
    static Types = {
        debit: 'debit',
        credit: 'credit',
    };

    hydrate({
        description = null,
        discountAmount = null,
        id = null,
        periodEndTime = null,
        periodStartTime = null,
        productId = null,
        quantity = null,
        type = InvoiceItemModel.Types.debit,
        unitPrice = null,
        ...otherFields
    } = {}) {
        this.description = description;
        this.discountAmount = discountAmount;
        this.id = id;
        this.periodEndTime = periodEndTime;
        this.periodStartTime = periodStartTime;
        this.productId = productId;
        this.quantity = quantity;
        this.type = type;
        this.unitPrice = unitPrice;

        this.product = EntityModel.fromEmbedded({
            fields: otherFields,
            entityName: 'product',
            model: ProductModel,
        });

        this.plan = EntityModel.fromEmbedded({
            fields: otherFields,
            entityName: 'plan',
            model: PlanModel,
        });
    }

    get price() {
        return this.unitPrice * this.quantity;
    }

    get productName() {
        return this.product ? this.product.name : 'Product';
    }

    get hasPeriod() {
        return this.periodStartTime && this.periodEndTime;
    }

    get isCredit() {
        return this.type === InvoiceItemModel.Types.credit;
    }

    getPayload() {
        return {
            description: this.description,
            discountAmount: this.discountAmount,
            periodEndTime: this.periodEndTime,
            periodStartTime: this.periodStartTime,
            productId: this.productId,
            quantity: this.quantity,
            type: this.type,
            unitPrice: this.unitPrice,
        };
    }
}
